var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"data-src":"https://old.happimobiles.com/blood-donation-happi/","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }